import IChart from '../../interfaces/IChart';
import {TableColumn} from '@vidazoo/ui-kit';

export const ChartsTableColumns: TableColumn<IChart>[] = [
    {title: '', key: 'checkbox', defaultWidth: 250},
    {title: 'Name', key: 'name', defaultWidth: 250, options: {search: {searchKey: 'name'}, freeze: true, sort: {sortKey: 'name'}}},
    {title: 'Type', key: 'type', defaultWidth: 250, options: {freeze: true, sort: {sortKey: 'type'}, filter: {
        filterKey: 'type', options: [{value: 'data_table', label: 'Diff Table'}, {value: 'summary', label: 'Summary'}, {value: 'performance', label: 'Performance'}]
    }}},
    {title: 'Date', key: 'created', defaultWidth: 250, options: {freeze: true, sort: {sortKey: 'created'}}},
    {title: 'Updated', key: 'updated', defaultWidth: 250, options: {freeze: true, sort: {sortKey: 'updated'}}},
    {title: 'Active', key: 'isActive', defaultWidth: 250, options: {sort: {sortKey: 'isActive'}}},
    {title: 'Actions', key: 'actions', defaultWidth: 100},
];
